export default defineAppConfig({
  icon: {
    mode: "css",
    cssLayer: "base",
  },
});
